import React, { useCallback, useState } from "react";
import { List, message } from "antd";
import { deleteAddress } from "@/services/addresses";
import EditAddressForm from "@/forms/Dealer/EditAddress/EditAddressForm";
import AddressBookItem from "./AddressBookItem";

const AddressBookItemList = ({ addresses, fetchingLatestAddresses, onEditSuccess, autoFillAddressFields }) => {
  const [addressEditId, setAddressEditId] = useState(null);
  const [addressDeleteIds, setAddressDeleteIds] = useState([]);
  const [addressIdsBeingDeleted, setAddressIdsBeingDeleted] = useState([]);

  const onClickDelete = useCallback(id => {
    setAddressDeleteIds(curr => [...curr, id]);
  }, []);

  const handleDeleteAddress = useCallback(
    async id => {
      setAddressIdsBeingDeleted(curr => [...curr, id]);

      let res;
      try {
        res = await deleteAddress(id);

        if (res.error) {
          throw new Error();
        } else {
          message.success("Successfully deleted address");
          setAddressDeleteIds(curr => curr.filter(addrId => addrId !== id));
          setAddressIdsBeingDeleted(curr => curr.filter(addrId => addrId !== id));

          if (typeof onEditSuccess === "function") {
            onEditSuccess();
          }
        }
      } catch (err) {
        console.error(err);
        message.error("Error deleting address!");
      } finally {
        setAddressIdsBeingDeleted(curr => [...curr, id]);
      }
    },
    [onEditSuccess],
  );

  const onClickUse = useCallback(
    id => {
      const addressToUse = addresses.find(addr => addr.id === id) ?? {};
      autoFillAddressFields(addressToUse);
    },
    [addresses, autoFillAddressFields],
  );

  const handleCancelDeleteAddress = useCallback(id => {
    setAddressDeleteIds(curr => curr.filter(addrId => addrId !== id));
  }, []);

  const renderItem = useCallback(
    item => {
      if (item.hide) return null;

      return (
        <AddressBookItem
          item={item}
          onClickEdit={() => setAddressEditId(item.id)}
          handleDeleteAddress={() => handleDeleteAddress(item.id)}
          addressDeleteIds={addressDeleteIds}
          isDeletingAddress={addressIdsBeingDeleted.includes(item.id)}
          onClickUse={() => onClickUse(item.id)}
          onClickDelete={() => onClickDelete(item.id)}
          handleCancelDeleteAddress={() => handleCancelDeleteAddress(item.id)}
        />
      );
    },
    [
      addressDeleteIds,
      addressIdsBeingDeleted,
      handleDeleteAddress,
      onClickUse,
      handleCancelDeleteAddress,
      onClickDelete,
    ],
  );

  if (addressEditId) {
    return (
      <EditAddressForm
        item={addresses.find(addr => addr.id === addressEditId)}
        onClickCancel={() => setAddressEditId(null)}
        onEditSuccess={onEditSuccess}
      />
    );
  }

  return <List rowKey="id" dataSource={addresses} renderItem={renderItem} loading={fetchingLatestAddresses} />;
};

export default AddressBookItemList;
